export default "__VITE_ASSET__CgmI88Xc__"